// Reenvía cada llamada a varios adapters. Sirve para auditar en uat o producción:
// con localStorage.ec_analytics_debug = "1" se monta PostHog + console, así se
// puede ver en la consola lo mismo que se está enviando.
import type { AnalyticsAdapter } from "../types";

export function createCompositeAdapter(adapters: AnalyticsAdapter[]): AnalyticsAdapter {
  const each = (fn: (adapter: AnalyticsAdapter) => void): void => {
    adapters.forEach((adapter) => {
      try {
        fn(adapter);
      } catch {
        // Un adapter que falla no debe impedir que los demás reciban el evento,
        // ni propagar el error a la app.
      }
    });
  };

  return {
    name: `composite(${adapters.map((a) => a.name).join("+")})`,
    init: () => each((a) => a.init()),
    track: (event, props, opts) => each((a) => a.track(event, props, opts)),
    identify: (id, traits) => each((a) => a.identify(id, traits)),
    register: (props) => each((a) => a.register(props)),
    page: (screen, props, opts) => each((a) => a.page(screen, props, opts)),
    reset: () => each((a) => a.reset()),
  };
}
